import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { usePatientsStore, useSelectFormStore, useForm } from "../../../hooks";
import { useAuthStore } from "../../../auth/hooks";
import { replaceNullToEmpty } from "../../../helpers";
import { maritalStatuses, patientFormFieldsByIpsId } from "../../data";
import {
  InputForm,
  SelectForm,
  LoadingData,
  ErrorMessage,
  CancelButton,
  MainButton,
} from "../../ui";
import { useFormMessages } from "../../hooks";

export const ModalEditPatient = ({ editPatient, setEditPatient, patient }) => {
  // Datos de hooks ----------------------------------------//
  const {
    // Props
    message,
    isLoading,

    // Methods
    startUpdatePatient,
  } = usePatientsStore();

  const {
    //props
    user,
  } = useAuthStore();

  const {
    documentTypes,
    countryPhones,
    genders,
    ipss,
    ratePlans,
    ethnicities,
  } = useSelectFormStore([
    "documentTypes",
    "countryPhones",
    "genders",
    "ipss",
    "ratePlans",
    "ethnicities",
  ]);

  // States ------------------------------------------------//
  const [validateForm, setValidateForm] = useState(false);
  const [formData, setFormData] = useState({});
  const [formValidations, setFormValidations] = useState({});

  // Formulario --------------------------------------------//
  const { formState, formValidation, onInputChange, isFormValid, onResetForm } =
    useForm(formData, formValidations);

  const {
    setFormSubmitted,
    showErrorMessage,
    showSuccessMessage,
    messageText,
  } = useFormMessages({
    message,
    setValidateForm,
  });

  // Funciones ---------------------------------------------//
  const onUpdatePatient = () => {
    setValidateForm(true);
    if (isFormValid) {
      setFormSubmitted(true);
      startUpdatePatient(formState);
    }
  };

  const defineForm = () => {
    const formfields =
      patientFormFieldsByIpsId[user.ips.id]?.fields ||
      patientFormFieldsByIpsId.default.fields;
    const formfValidations =
      patientFormFieldsByIpsId[user.ips.id]?.validations ||
      patientFormFieldsByIpsId.default.validations;

    // console.log("formfields", formfields);
    // console.log("formfValidations", formfValidations);

    if (Object.keys(formfields).length > 0) {
      setFormData(() => {
        const updated = {
          ...formfields,
          ipsId: user.ips.id,
          userId: "",
          id: "",
        };
        return updated;
      });
      setFormValidations(() => {
        const updated = {
          ...formfValidations,
        };
        return updated;
      });
    }
  };

  // Efectos -----------------------------------------------//
  useEffect(() => {
    if (patient) {
      const filteredData = Object.keys(formData).reduce((acc, key) => {
        const value = patient[key];
        acc[key] = value === null || value === undefined ? "" : value;
        return acc;
      }, {});

      setFormData(filteredData);
    }
  }, [patient]);

  useEffect(() => {
    if (user.ips.id) {
      defineForm();
    }
  }, [user]);

  // useEffect(() => {
  //   console.log("formState", formState);
  // }, [formState]);

  // useEffect(() => {
  //   console.log("formValidation", formValidation);
  // }, [formValidation]);

  useEffect(() => {
    if (!editPatient) {
      onResetForm();
      setValidateForm(false);
      setFormSubmitted(false);
    }
  }, [editPatient]);

  useEffect(() => {
    if (showSuccessMessage) {
      setEditPatient(false);
    }
  }, [showSuccessMessage]);

  return (
    <Modal
      show={editPatient}
      onHide={() => setEditPatient(false)}
      centered
      size="lg"
    >
      <Modal.Header closeButton>
        <h5 className="modal-title" id="exampleModalLabel1">
          Editar paciente
        </h5>
      </Modal.Header>
      <Modal.Body>
        <div className="row g-3">
          {/* Formulario estatico */}
          <>
            {"firstName" in formState && (
              <div className="col-md-6">
                <InputForm
                  label={"Nombres"}
                  type={"text"}
                  validation={formValidation.firstNameValid}
                  submit={validateForm}
                  name={"firstName"}
                  value={formState.firstName}
                  onInputChange={onInputChange}
                />
              </div>
            )}
            {"lastName" in formState && (
              <div className="col-md-6">
                <InputForm
                  label={"Apellidos"}
                  type={"text"}
                  validation={formValidation.lastNameValid}
                  submit={validateForm}
                  name={"lastName"}
                  value={formState.lastName}
                  onInputChange={onInputChange}
                />
              </div>
            )}
            {"documentTypeId" in formState && (
              <div className="col-md-6">
                <SelectForm
                  label={"Tipo de documento"}
                  options={documentTypes}
                  labelKey={"description"}
                  validation={formValidation.documentTypeIdValid}
                  submit={validateForm}
                  name={"documentTypeId"}
                  value={formState.documentTypeId}
                  onInputChange={onInputChange}
                />
              </div>
            )}
            {"document" in formState && (
              <div className="col-md-6">
                <InputForm
                  label={"Documento"}
                  type={"text"}
                  validation={formValidation.documentValid}
                  submit={validateForm}
                  name={"document"}
                  value={formState.document}
                  onInputChange={onInputChange}
                />
              </div>
            )}
            {"genderId" in formState && (
              <div className="col-md-6">
                <SelectForm
                  label={"Género"}
                  options={genders}
                  labelKey={"name"}
                  validation={formValidation.genderIdValid}
                  submit={validateForm}
                  name={"genderId"}
                  value={formState.genderId}
                  onInputChange={onInputChange}
                />
              </div>
            )}
            {"birthDate" in formState && (
              <div className="col-md-6">
                <InputForm
                  label={"Fecha de nacimiento"}
                  type={"date"}
                  placeholder={"Fecha de nacimiento"}
                  validation={formValidation.birthDateValid}
                  submit={validateForm}
                  name={"birthDate"}
                  value={formState.birthDate}
                  onInputChange={onInputChange}
                />
              </div>
            )}
            {"ratePlanId" in formState && (
              <div className="col-md-6">
                <SelectForm
                  label={"Plan de tarifa"}
                  options={ratePlans}
                  labelKey={"name"}
                  validation={formValidation.ratePlanIdValid}
                  submit={validateForm}
                  name={"ratePlanId"}
                  value={formState.ratePlanId}
                  onInputChange={onInputChange}
                />
              </div>
            )}
            {"ethnicityId" in formState && (
              <div className="col-md-6">
                <SelectForm
                  label={"Etnia"}
                  options={ethnicities}
                  labelKey={"name"}
                  validation={formValidation.ethnicityIdValid}
                  submit={validateForm}
                  name={"ethnicityId"}
                  value={formState.ethnicityId}
                  onInputChange={onInputChange}
                />
              </div>
            )}
            {"maritalStatus" in formState && (
              <div className="col-md-6">
                <SelectForm
                  label={"Estado civil"}
                  options={maritalStatuses}
                  labelKey={"name"}
                  validation={formValidation.maritalStatusValid}
                  submit={validateForm}
                  name={"maritalStatus"}
                  value={formState.maritalStatus}
                  onInputChange={onInputChange}
                />
              </div>
            )}

            {"country" in formState && (
              <div className="col-md-6">
                <InputForm
                  label={"Pais de residencia"}
                  type={"text"}
                  validation={formValidation.countryValid}
                  submit={validateForm}
                  name={"country"}
                  value={formState.country}
                  onInputChange={onInputChange}
                />
              </div>
            )}
            {"department" in formState && (
              <div className="col-md-6">
                <InputForm
                  label={"Departamento de residencia"}
                  type={"text"}
                  validation={formValidation.departmentValid}
                  submit={validateForm}
                  name={"department"}
                  value={formState.department}
                  onInputChange={onInputChange}
                />
              </div>
            )}
            {"city" in formState && (
              <div className="col-md-6">
                <InputForm
                  label={"Ciudad de residencia"}
                  type={"text"}
                  validation={formValidation.cityValid}
                  submit={validateForm}
                  name={"city"}
                  value={formState.city}
                  onInputChange={onInputChange}
                />
              </div>
            )}
            {"address" in formState && (
              <div className="col-md-6">
                <InputForm
                  label={"Dirección de residencia"}
                  type={"text"}
                  validation={formValidation.addressValid}
                  submit={validateForm}
                  name={"address"}
                  value={formState.address}
                  onInputChange={onInputChange}
                />
              </div>
            )}
            {"birthCountry" in formState && (
              <div className="col-md-6">
                <InputForm
                  label={"Pais de nacimiento"}
                  type={"text"}
                  validation={formValidation.birthCountryValid}
                  submit={validateForm}
                  name={"birthCountry"}
                  value={formState.birthCountry}
                  onInputChange={onInputChange}
                />
              </div>
            )}
            {"birthDepartment" in formState && (
              <div className="col-md-6">
                <InputForm
                  label={"Departamento de nacimiento"}
                  type={"text"}
                  validation={formValidation.birthDepartmentValid}
                  submit={validateForm}
                  name={"birthDepartment"}
                  value={formState.birthDepartment}
                  onInputChange={onInputChange}
                />
              </div>
            )}
            {"birthCity" in formState && (
              <div className="col-md-6">
                <InputForm
                  label={"Ciudad de nacimiento"}
                  type={"text"}
                  validation={formValidation.birthCityValid}
                  submit={validateForm}
                  name={"birthCity"}
                  value={formState.birthCity}
                  onInputChange={onInputChange}
                />
              </div>
            )}

            <div className="col-md-12">
              <hr className="flex-grow-1 m-0" />
            </div>
            {"countryPhoneId" in formState && (
              <div className="col-md-6">
                <SelectForm
                  label={"Prefijo celular"}
                  options={countryPhones}
                  labelKey={"prefix"}
                  validation={formValidation.countryPhoneIdValid}
                  submit={validateForm}
                  name={"countryPhoneId"}
                  value={formState.countryPhoneId}
                  onInputChange={onInputChange}
                />
              </div>
            )}
            {"phoneNumber" in formState && (
              <div className="col-md-6">
                <InputForm
                  label={"No. celular"}
                  type={"text"}
                  validation={formValidation.phoneNumberValid}
                  submit={validateForm}
                  name={"phoneNumber"}
                  value={formState.phoneNumber}
                  onInputChange={onInputChange}
                />
              </div>
            )}
            {"email" in formState && (
              <div className="col-md-12">
                <InputForm
                  label={"Correo electrónico"}
                  sublabel={"(opcional)"}
                  type={"text"}
                  validation={formValidation.emailValid}
                  submit={validateForm}
                  name={"email"}
                  value={formState.email}
                  onInputChange={onInputChange}
                />
              </div>
            )}
          </>

          {/* Mensajes */}
          <>
            {isLoading && (
              <div className="col-md-12">
                <LoadingData />
              </div>
            )}
            {showErrorMessage && (
              <div className="col-md-12">
                <ErrorMessage>{messageText}</ErrorMessage>
              </div>
            )}
          </>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <CancelButton
          type={"button"}
          onClick={() => setEditPatient(false)}
          disabled={isLoading}
        >
          Cancelar
        </CancelButton>
        <MainButton
          type={"button"}
          onClick={() => onUpdatePatient()}
          disabled={isLoading}
        >
          Guardar cambios
        </MainButton>
      </Modal.Footer>
    </Modal>
  );
};
